export default {
  heroTitle: "Time changes everything.",
  heroAccent: "Except knowledge.",
  heroLead:
    "Eras pass and cities transform, but the library remains — a store of knowledge open to every generation.",
  ctaLogin: "Sign in",
  ctaPortal: "Go to events",
  ctaEvents: "Events",
  ctaSearch: "Catalogue",
  newsKicker: "News",
  newsTitle: "What is happening at NBR",
  newsSubtitle: "Latest project updates — without leaving the homepage.",
  newsAll: "All news",
  newsEmpty: "No published news yet.",
  newsError: "Could not load news. Please try again later.",
  newsVisualLead: "A book is more than an object. It is a story that lives for centuries.",
  catalogKicker: "Catalogue",
  catalogTitle: "Bibliography in figures",
  catalogSubtitle:
    "An authority catalogue of persons, works, manifestations and prizes based on IFLA LRM.",
  catalogCta: "Open the catalogue",
  catalogSearchCta: "Search",
  catalogQueryCta: "Query by criteria",
  catalogStatsUnavailable: "Statistics temporarily unavailable",
  catalogExploreAria: "Go to the National Bibliographic Resource catalogue",
  depositKicker: "Copyright",
  depositTitle: "Work deposit",
  depositSubtitle:
    "Official registration and copyright protection for your works in the collections of the Russian State Library.",
  depositHowTitle: "How it works",
  depositStep1Title: "Fill in the form",
  depositStep1Desc: "Provide details about the work and author",
  depositStep2Title: "Upload a file",
  depositStep2Desc: "Attach an electronic copy of the work",
  depositStep3Title: "Receive a certificate",
  depositStep3Desc: "The deposit certificate will be emailed to you",
  depositRegistryTitle: "Public registry",
  depositRegistryAll: "All",
  depositApplyCta: "Submit an application",
  depositApplyHint: "Fill in the form, upload your file, and receive a certificate",
  depositApplyAria: "Submit a deposition application",
  depositExploreTitle: "Browse the full register",
  depositExploreHint: "Certified works in the RSL collections — search by category and certificate number",
  depositExploreCount: "{{count}} entries in the register",
  depositExploreAria: "Go to the public deposition register",
}
